// extracted by mini-css-extract-plugin
export default {"mixtapes":"Mixtapes-module_mixtapes__GzkG6"};